import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonSubmit } from 'src/app/core/models/button-submit.model';
import { ErrorMessage } from 'src/app/core/models/error-message.model';
import { OrgaoHandlerService } from 'src/app/modules/orgao/service/orgao-handler-service.service';
import { SweetalertCustom } from 'src/app/shared/utils/sweetalert-custom';
import { Util } from 'src/app/shared/utils/util';
import { environment } from 'src/environments/environment';
import { NavbarAuthModalComponent } from '../layouts/layout-auth/components/navbar-auth/navbar-auth-modal/navbar-auth-modal.component';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseUrl = environment.apiUrl;
  private namespaceProject = environment.namespaceProject;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private orgaoHandlerService: OrgaoHandlerService,
    public modalService: NgbModal
  ) { }

  /**
   * Obtem o token da sessão para utilizar nas requisições
   */
   public headerOptions(): any {
    // tratar caso tenha o token
    const TOKEN = localStorage.getItem(`${this.namespaceProject}.token`) ? 'Bearer ' + localStorage.getItem(`${this.namespaceProject}.token`) : '';

    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: TOKEN
      }),
      observe: 'response' as 'response'
    };
  }

  public login(errorMessage: ErrorMessage, obj: any, buttonSubmit?: ButtonSubmit) {

    buttonSubmit.buttonText = 'ACESSANDO';
    buttonSubmit.buttonSubmited = true;

    this.httpClient.post(this.baseUrl + 'usuario/login', JSON.stringify(obj), this.headerOptions())
      .subscribe(
        (response: any) => {
          this.setValueButtonSubmeted(buttonSubmit);
          if (response.status === 201 || response.status === 200) {
            this.successSend(response.body);
            this.openModalSelecionarOrgao();
          }
        },
        (error: any) => {
          Util.clearErrorMessage(errorMessage);
          Util.setErrorMessage(errorMessage, error, 'warning');
          this.setValueButtonSubmeted(buttonSubmit);
        }
      );
  }

  /**
   * Seta as infomações do usuário e token do localStorage
   * @param response Response da requisição
   */
  public successSend(response) {
    const usuario = response.data;
    const restricoes = response.data.perfil.restricoes;
    if (restricoes) {
      localStorage.setItem(`${this.namespaceProject}.restricoes`, btoa(JSON.stringify(restricoes.map(x => x.key))));
    }
    localStorage.setItem(`${this.namespaceProject}.token`, response.data.token);
    localStorage.setItem(`${this.namespaceProject}.usuario`, btoa(JSON.stringify(usuario)));
    localStorage.setItem(`${this.namespaceProject}.usuarioLogado`, btoa(JSON.stringify(response.data)));
    localStorage.setItem(`${this.namespaceProject}.perfil`, btoa(JSON.stringify(response.data.perfil.descricao)));
    if (response.data.primeiroAcesso) {
      return this.router.navigate(['auth/primeiro-acesso']);
    }
    if (response.data.orgaoId) {
      this.orgaoHandlerService.setOrgaoId = response.data.orgaoId;
      localStorage.setItem(`${this.namespaceProject}.orgao`, btoa(JSON.stringify(response.data.orgaoId)));
      localStorage.setItem(`${this.namespaceProject}.orgaoNome`, btoa(JSON.stringify(response.data.orgaoNome)));
      Util.setStatusPlanoAtivo(response.data.statusPlano);
    } else {
      localStorage.setItem(`${this.namespaceProject}.isSuperUser`, JSON.stringify(true));
    }
    return this.router.navigate(['/inicio']);
  }

  /**
   * Seta o nome e habilita a ação de submissão
   * @param buttonSubmit Botão de submissão
   */
  public setValueButtonSubmeted(buttonSubmit) {
    buttonSubmit.buttonText = 'ACESSAR';
    buttonSubmit.buttonSubmited = false;
  }

  /**
   * Função de alterar senha
   * @param errorMessage Menssagem de erro
   * @param obj Objeto da transmissão
   * @param buttonSubmit Botão de submissão
   */
  public changePassword(errorMessage: ErrorMessage, obj: any, buttonSubmit?: ButtonSubmit) {
    buttonSubmit.buttonText = 'ACESSANDO';
    buttonSubmit.buttonSubmited = true;

    this.httpClient.post(this.baseUrl + 'usuario/change-password', JSON.stringify(obj), this.headerOptions())
      .subscribe(
        (response: any) => {
          this.setValueButtonSubmeted(buttonSubmit);
          if (response.status === 201 || response.status === 200) {
            this.successSendRedirectChanged('Senha', 'Sua senha foi alterada com sucesso, faça o login novamente para valida-la.');
          }
        },
        (error: any) => {
          Util.clearErrorMessage(errorMessage);
          Util.setErrorMessage(errorMessage, error, 'warning');
          this.setValueButtonSubmeted(buttonSubmit);
        }
      );
  }

  /**
   * Função de redefinição de senha
   * @param errorMessage Menssagem de erro
   * @param obj Objeto de transmissão
   * @param buttonSubmit Botão de submissão
   */
  public redefinePassword(errorMessage: ErrorMessage, obj: any, buttonSubmit?: ButtonSubmit) {
    buttonSubmit.buttonText = 'REDEFININDO SENHA';
    buttonSubmit.buttonSubmited = true;

    this.httpClient.patch(this.baseUrl + 'usuario/reset-password', JSON.stringify(obj), this.headerOptions())
      .subscribe(
        (response: any) => {
          this.setValueButtonSubmitedReset(buttonSubmit);
          if (response.status === 201 || response.status === 200) {
            this.successSendResetPassword();
          }
        },
        (error: any) => {
          Util.clearErrorMessage(errorMessage);
          Util.setErrorMessage(errorMessage, error, 'warning');
          this.setValueButtonSubmitedReset(buttonSubmit);
        }
      );
  }

  /**
   * Seta o nome e habilita a ação de submissão
   * @param buttonSubmit Botão de submissão
   */
  public setValueButtonSubmitedReset(buttonSubmit) {
    buttonSubmit.buttonText = 'REDEFINIR SENHA';
    buttonSubmit.buttonSubmited = false;
  }

  /**
   * Função que exibe a mensagem de sucesso
   * @param name Nome(descrição) a ser exibida na mensagem
   * @param activeModal Variavel que ativa/desativa o modal
   */
  public successSendModal(name = '', activeModal?: NgbActiveModal) {
    SweetalertCustom.showAlertTimer(`${name} salvo(a) com sucesso!`, { type: 'success' })
      .then((result) => {
        if (result) {
          activeModal.close();
        }
      });
  }

  /**
   * Função que exibe a mensagem de sucesso e redireciona
   * @param name Nome(descrição) a ser exibida na mensagem
   */
   public  successSendRedirect(name = '') {
    SweetalertCustom.showAlertTimer(`${name} salva com sucesso!`, { type: 'success' })
      .then(() => {
        this.router.navigate([`/auth/login`]);
      });
  }

  public  successSendRedirectChanged(name = '', description = '') {
    SweetalertCustom.showAlertConfirm(`${name} salva com sucesso!`, { type: 'success' }, 'Ok', description)
      .then(() => this.router.navigate([`/auth/`]));
  }

  public successSendResetPassword() {
    SweetalertCustom.showAlertConfirm(`Senha resetada com sucesso!`, { type: 'success' }, 'Ok', 'Uma nova senha foi gerada e enviada para seu e-mail, para continuar faça login novamente.')
      .then(() => {
        if (!Util.verificaAdm) {
          this.router.navigate([`/auth/`]);
        }
      })
  }

  /**
   * Função para abrir o modal de seleção de orgão apenas 1 vez após o login
   */
   private openModalSelecionarOrgao(): void {

    if (!Util.verificaAdm()) { return; }

    const modal = Util.openModal(this.modalService, NavbarAuthModalComponent, 'lg');
    modal.componentInstance.selecionarOrgaoInicial = false;
    modal.componentInstance.selecionarOrgaoBotao = true;
    modal.componentInstance.botaoSair = false;

  }

}
